export const newsItems = [
  {
    id: 1,
    title: "Honeywell BMS: Smarter, Safer, More Efficient Buildings",
    date: "29/07/2025",
    category: "Building Management Systems",
    image: require('../assets/news/bms.avif'),
    excerpt:
      "How Honeywell BMS unifies HVAC, fire, and access systems to reduce energy costs and improve occupant safety.",
    link: "https://buildings.honeywell.com/us/en/brands/our-brands/bms",
  },
  {
    id: 2,
    title: "VoltVision NightOwl Off‑Grid Solar Inverter (3.6 kW / 6 kW)",
    date: "15/02/2025",
    category: "Inverters",
    image: require('../assets/news/night_owl.webp'),
    excerpt:
      "VoltVision’s NightOwl off‑grid inverter ensures seamless backup power with high efficiency, durability, and easy renewable integration.",
    link: "https://voltvision.uk/our-products/inverters/",
  },
  {
    id: 3,
    title: "Safe Eye 10G Industrial SFP (Single‑mode, Dual Fiber, 10KM)",
    date: "18/03/2025",
    category: "SFP Transceivers",
    image: require('../assets/news/sfp.webp'),
    excerpt:
      "SKU SA-SD1310: 10G SFP+ for single‑mode fiber up to 10km, 1310nm DFB laser, <1W power, LC connector, strong EMI/ESD, IEC‑60825, RoHS, SFF‑8472 compliant.",
    link: "https://safeeye.uk/product/10g-industrial-sfpsingle-mode-dual-fiber-10km/",
  },
];


